import React, { useRef } from 'react'
import { capabilitiesErrorAtom } from 'atoms/capabilities'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { PageHeader } from 'components/header/PageHeader'
import { logSentryErrorAndGetTraceId } from 'utils/sentry'
import { AddCustomerAgreementCta } from './AddCustomer/AddCustomerAgreementCta'
import { CustomersListV2 } from './CustomersListV2/CustomersListV2'

export const CustomersV2 = () => {
  const { t } = useTranslation()
  const capabilitiesError = useAtomValue(capabilitiesErrorAtom)
  const refetchRef = useRef<() => void>(() => {})

  if (capabilitiesError) {
    const sentryTraceId = logSentryErrorAndGetTraceId(
      `Failed API request to /v1/capabilities/bulk with status ${capabilitiesError?.status}`,
      capabilitiesError
    )

    return (
      <RequestErrorStatusCard
        title={t('errorMessages.featureErrorTitle')}
        sentryTraceId={sentryTraceId}
      />
    )
  }

  const AddButton = <AddCustomerAgreementCta refetchCustomers={() => refetchRef.current()} />

  return (
    <Box paddingB={8}>
      <PageHeader description={t('customers.descriptionV2')} renderRightSection={AddButton} />
      <CustomersListV2
        AddButton={AddButton}
        onRefetch={refetch => {
          refetchRef.current = refetch
        }}
      />
    </Box>
  )
}
